import Footer from "./Footer";
export * from "./Footer";
export default Footer;